import * as Common from "../../commons/common"

export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
  }
}

export class RowItem {
  tdColumns: any[] = new Array<any>();

  constructor(score_rates: any[]){
    
    this.tdColumns.push(score_rates[0].part1);
    this.tdColumns.push(score_rates[0].allot);

    const totalScore = Common.sumArray(score_rates.map((x: any) => x.sum_score));
    const totalAllot = Common.sumArray(score_rates.map((x: any) => x.sum_allot));
    this.tdColumns.push(Math.round(totalScore / totalAllot  * 1000) / 10);

    score_rates.forEach((x: any) => {
      this.tdColumns.push(Math.round(x.sum_score / x.sum_allot * 1000) / 10);
    });
  }
}